import { AutogenModelInterfaceCodeLookup, AutogenRowInterfaceCodeLookup } from "./autogen/AutogenModelInterfaceCodeLookup";

export class ModelInterfaceCodeLookup extends AutogenModelInterfaceCodeLookup<RowInterfaceCodeLookup> {
	constructor() {
		super(RowInterfaceCodeLookup);
	}
}

export class RowInterfaceCodeLookup extends AutogenRowInterfaceCodeLookup {
}